import ErnstigeBloedingenOnderDoacFactorXa from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-doac-factor-xa.json";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderDoacFactorXa,
  React
};